import rootConfig from "../../rootConfig";

export default {
  ...rootConfig,
};
